import { useEffect } from 'react';
import type React from 'react';

import { Link } from '@change/ds-core-ui/Link';
import { Text } from '@change/ds-core-ui/Text';

import { Translate, TranslateHtml } from '@change-corgi/core-react/i18n';

import { useEmailVerificationStep } from './hooks/useEmailVerificationStep';

export const EmailVerificationStep: React.FC<EmptyProps> = () => {
	const {
		data: { supportUrl },
		actions: { trackStepView, useDifferentEmail },
	} = useEmailVerificationStep();

	useEffect(() => {
		trackStepView();
	}, [trackStepView]);

	return (
		<div>
			<Text size="medium" fontWeight="bold">
				<TranslateHtml value="corgi.login_or_signup.verify_email.help.title" />
			</Text>
			<div>
				<ul className="list-inside list-disc px-2 py-2">
					<li>
						<Text>
							<Translate value="corgi.login_or_signup.verify_email.help.tip1" />
						</Text>
					</li>
					<li>
						<Link
							as="button"
							onClick={useDifferentEmail}
							data-testid="use-different-email"
							data-qa="use-different-email"
						>
							<Translate value="corgi.login_or_signup.verify_email.help.tip3" />
						</Link>
					</li>
					<li>
						<Link href={supportUrl} target="_blank" data-testid="contact-support" data-qa="contact-support">
							<Translate value="corgi.login_or_signup.verify_email.help.contact_support" />
						</Link>
					</li>
				</ul>
			</div>
		</div>
	);
};
